import { tns } from 'tiny-slider/src/tiny-slider'


export default () => {

	const els = [...document.querySelectorAll('.image-carousel')]
	els.map(el => {

		const carouselEl = el.querySelector('.image-carousel__inner')
		if (!carouselEl) return null

		const carouselControls = el.querySelector('.image-carousel__controls')


		// remove classes for setting pagewidth before carousel inits
		//carouselEl.classList.remove('grid')
		//carouselEl.classList.remove('page-width')

		return tns({
			container: carouselEl,
			items: 1,
			controls: true,
			controlsContainer: carouselControls,
			nav: false,
			//navContainer: carouselNav,
			touch: true,
			mouseDrag: true,
			loop: true,
			autoplay: true,
			speed: 700,
			autoplayTimeout: 7000,
			autoplayButtonOutput: false,		
		})
	})
}


